import CommonStore from './CommonStore';

export default CommonStore;